import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import App from './App'
import store from './redux/store'
import i18n from './i18n'

import './index.css'
import 'antd/dist/antd.css' // or 'antd/dist/antd.less'

Sentry.init({
  dsn: 'https://882beedc69f947b185562e49f39cd1aa@o435752.ingest.sentry.io/5687306',
  environment: process.env.REACT_APP_ENV || 'development',
})

const rootElement = document.getElementById('root')

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </I18nextProvider>
    </BrowserRouter>
  </Provider>,
  rootElement,
)
